// PixiShape's fill rule (`_draw`, solid branch), shared by the field sign, the hit test and the stage pick.

/** Signed area of a rawPath segment's anchors (`[x0, y0, c1x, c1y, c2x, c2y, x1, y1, …]`), control points ignored as PixiShape ignores them. */
export const anchorArea = seg => {
	let area = 0
	const n = 1 + Math.floor((seg.length - 2) / 6)
	for (let k = 0; k < n; k++) {
		const i = k * 6
		const j = ((k + 1) % n) * 6
		area += seg[i] * seg[j + 1] - seg[j] * seg[i + 1]
	}
	return area / 2
}

/**
 * Per subpath: 1 fills (the first drawable one, and any later one of its winding or of zero area), −1 is a hole in the latest fill before it (the opposite winding), 0 draws nothing (absent, or under one cubic).
 * @param {Array<number[]|undefined>} segments rawPath segments, one per subpath
 * @returns {Int8Array}
 */
export const subpathRoles = segments => {
	const roles = new Int8Array(segments.length)
	let first = 0
	for (let i = 0; i < segments.length; i++) {
		const seg = segments[i]
		if (!seg || seg.length < 8) continue
		const sign = Math.sign(anchorArea(seg))
		if (!first) {
			first = sign || 1
			roles[i] = 1
		} else roles[i] = (sign || first) === first ? 1 : -1
	}
	return roles
}

/**
 * One subpath folded into a point's state (bit 0: inside the open fill so far, bit 1: inside an earlier, closed one), `inside` 0/1 for the point in that subpath (even-odd). Start at 0; `filled(state)` reads the result.
 * @param {number} state @param {number} role @param {number} inside
 */
export const foldRole = (state, role, inside) =>
	role > 0 ? ((state | (state << 1)) & 2) | inside : role < 0 && inside ? state & 2 : state

export const filled = state => (state | (state >> 1)) & 1

/**
 * Whether a point is filled, given `roles` and `inSubpath(i)`, the point inside subpath i (even-odd).
 * @param {Int8Array} roles @param {(i: number) => boolean} inSubpath
 */
export const insideByRoles = (roles, inSubpath) => {
	let state = 0
	for (let i = 0; i < roles.length; i++) if (roles[i]) state = foldRole(state, roles[i], inSubpath(i) ? 1 : 0)
	return filled(state) === 1
}
